import { axiosInstance } from "../../utils/axios";

export const getEmployees = async () => {
  const { data: firstPageData } = await axiosInstance.get('api/v1/control/employees/?page=1');
  const { count, results: firstResults, per_page: perPage } = firstPageData;

  let allEmployees = [...(firstResults || [])];

  if (count > allEmployees.length) {
    const limit = perPage || 50;
    const totalPages = Math.ceil(count / limit);
    const promises = [];
    for (let i = 2; i <= totalPages; i += 1) {
      promises.push(axiosInstance.get(`api/v1/control/employees/?page=${i}`));
    }

    const responses = await Promise.all(promises);
    responses.forEach((response) => {
      const { data } = response;
      allEmployees = [...allEmployees, ...(data.results || [])];
    });
  }

  return {
    count,
    results: allEmployees
  };
};

export const getEmployeeByEmail = async (email) => {
  const { results } = await getEmployees();
  return results.find((emp) => emp.user?.email === email);
};

export const updateEmployee = (employee) => 
  axiosInstance.patch(`api/v1/control/employees/${employee.uuid}/`, employee)
    .then((response) => response.status);

export const createEmployee = (employee) => 
  axiosInstance.post('api/v1/control/employees/', employee)
    .then((response) => response.status);